import { api } from '../lib/api';
import { SpaceCanvas } from './SpaceCanvas';
import { FolderView } from './FolderView';
import { DocumentEditor } from './DocumentEditor';

interface MainAreaProps {
  activeNodeId: string | null;
  onActivate: (id: string) => void;
}

export function MainArea({ activeNodeId, onActivate }: MainAreaProps) {
  const nodesQuery = api.treeNodes.list.useQuery();
  const activeNode = nodesQuery.data?.find((n) => n.id === activeNodeId);

  const resolvedSpace = api.spaces.resolveByTreeNode.useQuery(
    { treeNodeId: activeNodeId ?? '' },
    {
      enabled: !!activeNodeId && activeNode?.kind === 'space',
    },
  );

  if (!activeNodeId || !activeNode) {
    return (
      <main className="flex-1 flex items-center justify-center text-ink-faint_l dark:text-ink-faint_d p-8">
        <div className="text-center max-w-md">
          <h2 className="text-lg font-medium mb-2 text-ink-light dark:text-ink-dark">MyKanban</h2>
          <p className="text-sm">
            Выбери узел в дереве слева. Создай папку, проект, пространство или документ — и наполняй структуру.
          </p>
        </div>
      </main>
    );
  }

  if (activeNode.kind === 'space' && resolvedSpace.data) {
    return <SpaceCanvas spaceId={resolvedSpace.data.id} />;
  }

  if (activeNode.kind === 'project') {
    return (
      <main className="flex-1 overflow-auto p-8">
        <header className="mb-6">
          <h1 className="text-xl font-semibold">{activeNode.title ?? 'Проект'}</h1>
          <p className="text-sm text-ink-faint_l dark:text-ink-faint_d mt-1">Проект</p>
        </header>
        <section className="rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 p-5">
          <h2 className="text-sm font-semibold text-amber-800 dark:text-amber-200 mb-2">
            Функционал проекта в разработке
          </h2>
          <p className="text-sm text-amber-700 dark:text-amber-300">
            Проект — это самостоятельная сущность, не папка и не пространство.
            Что именно он будет делать — пока не определено.
          </p>
        </section>
      </main>
    );
  }

  if (activeNode.kind === 'folder') {
    return (
      <FolderView
        nodeId={activeNode.id}
        title={activeNode.title ?? 'Папка'}
        onActivate={onActivate}
      />
    );
  }

  if (activeNode.kind === 'document') {
    return (
      <DocumentEditor
        treeNodeId={activeNode.id}
        title={activeNode.title ?? 'Документ'}
        onActivate={onActivate}
      />
    );
  }

  return (
    <main className="flex-1 flex items-center justify-center text-ink-faint_l">
      Загрузка…
    </main>
  );
}
